export const CREATE_AMBASSADOR = 'CREATE_AMBASSADOR'
export const UPDATE_AMBASSADOR = 'UPDATE_AMBASSADOR'
export const GET_AMBASSADOR_USER_DATA = 'GET_AMBASSADOR_USER_DATA'
export const GET_AMBASSADOR_HISTORY_DATA = 'GET_AMBASSADOR_HISTORY_DATA'
export const GET_AMBASSADOR_BY_UTM = 'GET_AMBASSADOR_BY_UTM'
export const EXPORT_AMBASSADORS_PAYOUT_CSV = 'EXPORT_AMBASSADORS_PAYOUT_CSV'
export const EXPORT_AMBASSADOR_LIST_CSV = 'EXPORT_AMBASSADOR_LIST_CSV'
export const EXPORT_AMBASSADOR_SIGNUPS_CSV = 'EXPORT_AMBASSADOR_SIGNUPS_CSV'
export const EXPORT_AMBASSADOR_CONVERSIONS_CSV = 'EXPORT_AMBASSADOR_CONVERSIONS_CSV'
export const EXPORT_AMBASSADOR_LEADS_CSV = 'EXPORT_AMBASSADOR_LEADS_CSV'
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN'
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'
export const GET_ALL_AMBASSADORS_DATA = 'GET_ALL_AMBASSADORS_DATA'
export const GET_CAMPAIGN_DETAIL_DATA = 'GET_CAMPAIGN_DETAIL_DATA'

export function createAmbassador (data) {
  return {
    type: CREATE_AMBASSADOR,
    payload: data,
  }
}

export function createCampaign (data) {
  return {
    type: CREATE_CAMPAIGN,
    payload: data,
  }
}

export function updateCampaign (data) {
  return {
    type: UPDATE_CAMPAIGN,
    payload: data,
  }
}

export function getAllAmbassadorsData (data) {
  return {
    type: GET_ALL_AMBASSADORS_DATA,
    payload: data,
  }
}

export function updateAmbassador (values, uuid) {
  return {
    type: UPDATE_AMBASSADOR,
    payload: { values, uuid },
  }
}

export function getAmbassadorUserData (email) {
  return {
    type: GET_AMBASSADOR_USER_DATA,
    payload: email,
  }
}

export function getAmbassadorByUtm (utm) {
  return {
    type: GET_AMBASSADOR_BY_UTM,
    payload: utm,
  }
}

export function getAmbassadorHistoryData (data) {
  return {
    type: GET_AMBASSADOR_HISTORY_DATA,
    payload: data,
  }
}

export function exportAmbassadorPayoutCSV () {
  return {
    type: EXPORT_AMBASSADORS_PAYOUT_CSV,
  }
}

export function exportAmbassadorListCSV () {
  return {
    type: EXPORT_AMBASSADOR_LIST_CSV,
  }
}

export function exportAmbassadorSignupsCSV () {
  return {
    type: EXPORT_AMBASSADOR_SIGNUPS_CSV,
  }
}

export function exportAmbassadorConversionsCSV () {
  return {
    type: EXPORT_AMBASSADOR_CONVERSIONS_CSV,
  }
}

export function exportAmbassadorLeadsCSV () {
  return {
    type: EXPORT_AMBASSADOR_LEADS_CSV,
  }
}

export function getCampaignDetailData () {
  return {
    type: GET_CAMPAIGN_DETAIL_DATA,
  }
}
